module.exports = __webpack_public_path__ + "img/fouad-whatsapp-logo.93814961.png";